import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  reportId: null,
  currentReportId: null,
  chatId: null,
};

const reportSlice = createSlice({
  name: 'report',
  initialState,
  reducers: {
    setCurrentReportId: (state, action) => {
      state.currentReportId = action.payload;
    },
    setReportId: (state, action) => {
      state.reportId = action.payload;
    },
    setChatId: (state, action) => {
      state.chatId = action.payload;
    },
  },
});

export const { setCurrentReportId, setReportId, setChatId } = reportSlice.actions;
export default reportSlice.reducer;
